export default __webpack_public_path__ + "static/media/new-jersey.64737951.jpg";